export default __webpack_public_path__ + "static/media/VANTEC20AARRAYBLANCOr.b2a40418.png";